<template>
    <div class="variants-wrap container">
        <div class="d-flex align-items-center flex-column py-5">
            <div v-if="!isMobile" class="variants-product">
                <div :class="['variants-product-img', {'variants-product-img--no-img': !productItem.images.length}]" :style="!!productItem.images.length ? `background-image: url(${_.first(productItem.images).thumb})` : ''"></div>
                <div class="variants-product-info">
                    <div class="variants-product-subtitle">{{ product.name }}, {{ productItem.name }}</div>
                    <div class="variants-product-title">{{ $t('choose_variant') }}</div>
                </div>
            </div>
            <ul class="variants">
                <li class="variants__item" v-for="(variant, i) in variants" :key="i">
                    <a href="#" @click.prevent="next(variant)">
                        <div class="variants__item-name">{{ variant.name }}</div>
                        <div class="variants__item-price">
                            <small>{{ $t('piece') }}</small>
                            {{ variant.price | currency }}
                        </div>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
  import orderStep3DigitalVariants from 'src/mixins/orderStep3DigitalVariantsComponent';

  export default {
    mixins: [orderStep3DigitalVariants],
  };
</script>